import React from 'react';
import { string, bool, shape, arrayOf } from 'prop-types';

import CardBlogCarousel from '@seo-frontend-components/card-blog-carousel';
import CardBlogCarouselMobile from '@seo-frontend-components/card-blog-carousel-mobile';

import { UI_LANDING_STYLE_PREFIX } from '../../../constants/appConstants';

const namespace = `${UI_LANDING_STYLE_PREFIX}-comparison`;

const blogsToViewDefault = '3';

const CarouselBlog = (props) => {
  const {
    device,
    jsDisabled,
    value: { title, blogs },
  } = props;

  const component =
    device === 'desktop' ? (
      <CardBlogCarousel
        blogEntries={blogs}
        supportWebP
        jsDisabled={jsDisabled}
        blogsToViewDefault={blogsToViewDefault}
      />
    ) : (
      <CardBlogCarouselMobile
        blogEntries={blogs}
        supportWebP
        jsDisabled={jsDisabled}
      />
    );

  return (
    <div className={`${namespace}-section-blog ${namespace}-section`}>
      <div className={`${namespace}-content-blog`}>
        <h3 className={`${namespace}-section-blog-title`}>{title}</h3>
        {component}
      </div>
    </div>
  );
};

CarouselBlog.propTypes = {
  device: string.isRequired,
  jsDisabled: bool.isRequired,
  value: shape({
    title: string.isRequired,
    blogs: arrayOf(
      shape({
        url: string.isRequired,
        title: string.isRequired,
        description: string.isRequired,
        last_modified: string.isRequired,
        image: shape({
          alt: string.isRequired,
          url: string.isRequired,
        }),
        tags_metadata: arrayOf(
          shape({
            url: string.isRequired,
            name: string.isRequired,
          }),
        ),
      }),
    ),
  }).isRequired,
};

export default CarouselBlog;
